import { isChrome, isEdge, isFirefox, isIE, isSafari } from '../helpers/getIEVersion';
declare const InstallTrigger: any;
declare const safari: any;
export function BrowserAlert() {
    let body = document.querySelector('body');

    let allMessage = document.querySelector('[data-browser-message-close="all"]');
    if (allMessage) {
        setupBrowserMessage('all');
    }
    else {
        if (isIE()) {
            setupBrowserMessage('ie');
        }
        else if (isEdge()) {
            setupBrowserMessage('edge');
        }
        else if (isChrome()) {
            setupBrowserMessage('chrome');
        }
        else if (isFirefox()) {
            setupBrowserMessage('firefox');
        }
        else if (isSafari()) {
            setupBrowserMessage('safari');
        }
    } 

    function addBodyClass(value: string) {
        body.classList.add(`${value}-browser`);
    }

    function setupBrowserMessage(browser: string) {
        addBodyClass(browser);
        let closeElement = getMessageCloseElement(browser);
        if (closeElement) {
            closeElement.addEventListener("click", closeBrowserMessage);
        }
    }
}


function getMessageCloseElement(browser: string) {
    return document.querySelector(`[data-browser-message-close="${browser}"]`);
}

function closeBrowserMessage() {
    let messageContainer = document.querySelector('[data-browser-message-container]');
    if (messageContainer) {
        messageContainer.classList.add('closed');
    }

    requestCloseMessage();
}

const ApiRoute = '/api/session/closeMessage';
async function requestCloseMessage(): Promise<void> {
    return await window.fetch(ApiRoute, { method: 'post' })
        .then(() => {
            return;
        });
}